import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import Slider from "react-slick";
import {Link, useLocation} from "react-router-dom";
import { useGetProfitOffersQuery } from "redux/slices/offers/profitOffersApi";
import Cookies from 'js-cookie';
import qs from "qs";

// Components
import {
	AdvantagesLandingItem,
	GeoMap,
	ContactsWidget,
	IndividualAdvantages,
	ModalReviews,
	OfferCard,
	OfferCardSkeleton,
	ReviewsBlock,
	SliderBlock,
	SliderEvents
} from "components/public";
import { Button } from "components/general";

// Utils
import { useModalContext } from "utils/customHooks/ModalContext";
import { Translate } from "utils/translations/Translate";

// Styles
import styles from './Main.module.scss'

// Images
import logoCPA from 'assets/images/general/CPA-logo.png'
import dollar from 'assets/images/public/motivation/dollar.svg'
import slide1 from "assets/images/public/main_slider/slide1.svg";
import slide2 from "assets/images/public/main_slider/slide2.svg";
import slide3 from "assets/images/public/main_slider/slide3.svg";
import slide4 from "assets/images/public/main_slider/slide4.svg";
import slide5 from "assets/images/public/main_slider/slide5.svg";

import event1 from "assets/images/public/slider_events/0025.png";
import event2 from "assets/images/public/slider_events/0151.png";
import event3 from "assets/images/public/slider_events/0022.png";
import event4 from "assets/images/public/slider_events/kz2.png";
import event5 from "assets/images/public/slider_events/kz3.png";
import event6 from "assets/images/public/slider_events/kz4.png";
import event7 from "assets/images/public/slider_events/semp1.png";
import event8 from "assets/images/public/slider_events/semp2.png";
import event9 from "assets/images/public/slider_events/semp3.png";
import event10 from "assets/images/public/slider_events/9904.png";
import event11 from "assets/images/public/slider_events/9899.png";
import event12 from "assets/images/public/slider_events/9927.png";
import event13 from "assets/images/public/slider_events/9928.png";
import event14 from "assets/images/public/slider_events/9932.png";

// Path
import {LOGIN_PATH} from "../../../config/routing/path";

function Main() {
	const { showRegLogModal } = useModalContext();
	const { lang } = useSelector(state => state.translations);
	const location = useLocation();

	// initialize translate class
	const translation = new Translate('public/main', lang)
	const t = translation.getWord()

	// query offers
	const { data, isLoading } = useGetProfitOffersQuery(lang)

	// for top double slider
	const [nav1, setNav1] = useState();
	const [nav2, setNav2] = useState();

	// for reviews block double slider
	const [rev1, setRev1] = useState();
	const [rev2, setRev2] = useState();

	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const [tempdata, setTempdata] = useState([])

	const getData = useCallback((name, position, link, allText, photo) => {
		let tempData = [name, position, link, allText, photo]
		setTempdata(() => [1, ...tempData])
		handleShow()
	}, [])

	// if there is referral id in query string - add it to cookies
	useEffect(() => {
		const params = qs.parse(window.location.search.substring(1))

		if (params.rid) {
			Cookies.set('rid', params.rid)
		}
	}, [])

	useEffect(() =>{

		if(location.pathname === LOGIN_PATH){
			showRegLogModal('login');
		}

	},[location])

	const individualAdvantages = {
		title: t('для вебмастеров'),
		subtitle: t('технологические и личные преимущества'),
		list: [
			{
				header: t('Финансовые офферы в любом ГЕО'),
				text: t('Если в нашей системе нет интересующих вас ГЕО или офферов, обратитесь в саппорт и мы в максимально сжатые сроки [до 15 дней] подключим их для Вас.')
			},
			{
				header: t('Максимальные ставки на рынке'),
				text: t('Мы работаем с минимальной маржей и зарабатываем на объеме. Это позволяет нам делать наиболее выгодные ставки для вебмастеров [по 90% офферам в PDL-profit ставка будет выше на 5-15%].')
			},
			{
				header: t('Мгновенные выплаты. 0 дней холд'),
				text: t('Просто заказываешь выплату и получаешь деньги. За счет нашей оборотки новички становятся ТОПами.')
			},
			{
				header: t('Технологические преимущества'),
				text: t('SmartLink, Конструктор витрин, Mobile – у нас уже есть все необходимое для увеличения эффективности Вашей работы с финансовым трафиком. Еще мы готовы воплощать Ваши идеи – просто обратитесь в саппорт.')
			},
			{
				header: t('Персональный менеджер'),
				text: t('Вы не только получаете персонального саппорт менеджера, который глубоко в теме трафика и всегда на связи. Он также готов помочь подобрать наиболее профитный оффер под Ваш трафик.')
			}
		]
	}

	const generalAdvantages = [
		{
			title: t('SmartLink'),
			text: t('SmartLink основанный на машинном обучении позволяет лить весь трафик в один URL, а система направит его туда, где он сконвертит лучше')
		},
		{
			title: t('Конструктор витрин'),
			text: t('Самый удобный и понятный на рынке. Количество вариантов витрин потенциально бесконечно. Создайте ту, которая будет конвертить Ваш траф лучше всего. Без дизайнеров, верстальщиков и возни с хостингом')
		},
		{
			title: t('Интеграции с GA4, FB'),
			text: t('Настраивайте готовые интеграции с источниками трафика для обучения и оптимизации ваших рекламных кампаний.')
		},
		{
			title: t('SMS SENDER'),
			text: t('Запускайте рассылки по собранным контактам прямо из кабинета по любому из 12 доступных ГЕО.')
		},
		{
			title: t('API'),
			text: t('Показывайте только актуальную информацию об офферах на своей витрине с помощью Offers API, повышайте конверсию своих связок с помощью Consumers API, ведите учет статистики и баланса в своих системах используя Statistic, Conversions и Balance API.')
		},
	]

	const sliderData = [
		{
			img: slide1,
			topHeader: t('0 дней'),
			midHeader: t('Холда активов'),
			text: t('Просто заказываешь выплату и получаешь деньги. За счет нашей оборотки новички становятся ТОПами'),
			reg: t('Регистрация')
		},
		{
			img: slide2,
			topHeader: t('Финансовые офферы'),
			midHeader: t('в любом ГЕО'),
			text: t('Если в нашей системе нет интересующих Вас ГЕО или офферов, обратитесь в саппорт и мы в максимально сжатые сроки (до 15 дней) подключим их для Вас'),
			reg: t('Регистрация'),
			fz: true
		},
		{
			img: slide3,
			topHeader: t('Максимальные ставки'),
			midHeader: t('на рынке'),
			text: t('Мы работаем с минимальной маржей и зарабатываем на объеме. Это позволяет нам делать наиболее выгодные ставки для вебмастеров (по 90% офферам в PDL-Profit ставка будет выше на 5-15%)'),
			reg: t('Регистрация'),
			fz: true
		},
		{
			img: slide4,
			topHeader: t('Широкий'),
			midHeader: t('выбор инструментов'),
			text: t('Smartlink, конструктор витрин, SMS-сендер, гибкое API, интеграции с рекламными кабинетами - мы предоставляем широкий технологический спектр для вашего трафика.'),
			reg: t('Регистрация'),
			fz: true
		},
		{
			img: slide5,
			topHeader: t('Гарантия'),
			midHeader: t('100% аптайма системы'),
			text: t('Мы гарантируем стабильную работу трекера и полностью возмещением потери по трафику в случае даунтайма, рассчитывая средние показатели.'),
			reg: t('Регистрация'),
			fz: true
		}
	]

	const events = [
		{
			title: t('Митап с партнерами'),
			location: t('Киев'),
			date: '11.2022',
			description: t('Вечеринка с вебмастерами в просторной локации в центре Киева. Бар, диджей сет, покер, кальяны, розыгрыш Starlink.'),
			images: [event1, event2, event3]
		},
		{
			title: t('Митап с рекламодателями'),
			location: t('Алматы'),
			date: '08.2023',
			description: t('Отдых и нетворкинг с ведущими рекламодателями Казахстана в открытой локации в Алматы. Вкусная еда, кальяны, приятная атмосфера.'),
			images: [event4, event5, event6]
		},
		{
			title: t('PDL-Profit на Sempro 2023'),
			location: t('Киев'),
			date: '10.2023',
			description: t('Команда PDL-Profit на масштабной конференции Sempro 2023 и поцелуй от нашего aff teamlead Ивана'),
			images: [event7, event8, event9]
		},
		{
			title: t('Новый Год в Казахстане'),
			location: t('Алматы'),
			date: '12.2023',
			description: t('PDL-Profit на новогоднем мероприятии рекламодателей в Казахстане.'),
			images: [event10, event11]
		},
		{
			title: t('Митап с рекламодателями'),
			location: t('Киев'),
			date: '01.2024',
			description: t('Отдых и нетворкинг с украинскими рекламодателями в уютном ресторане в Киеве. Вкусная еда, кальяны, приятная атмосфера.'),
			images: [event12, event13, event14]
		},
		
	  ];

	return (
		<div className='main'>
			<div className="container">
				<section className="main__slider">
					<div className="main__slider--wrapper">
						<Slider
							asNavFor={nav2} ref={(slider1) => setNav1(slider1)}>
							{
								sliderData.map((item, i) => (
									<SliderBlock key={i} {...item} showRegLogModal={showRegLogModal} />
								))
							}
						</Slider>
						<Slider
							className='slick__dots'
							asNavFor={nav1}
							ref={(slider2) => setNav2(slider2)}
							slidesToShow={5}
							slidesToScroll={1}
							swipeToSlide={true}
							focusOnSelect={true}
							centerMode={true}
							arrows={false}
							useTransform={false}
							responsive={[{
								breakpoint: 992,
								settings: {
									slidesToShow: 3
								}

							}]}
							autoplaySpeed={5000}
							autoplay={true}
						>
							<h3>01</h3>
							<h3>02</h3>
							<h3>03</h3>
							<h3>04</h3>
							<h3>05</h3>
						</Slider>

					</div>
					<div className='after__slider d-flex align-items-center'>
						<div className='after__slider--img'>
							<img src={logoCPA} alt="logo" />
						</div>
						<div className='after__slider--text'>{t('Международная CPA сеть')}
							<br />
							{t('в финансовой вертикали')}
						</div>
					</div>
				</section>

			</div>
			
			<section className={styles.map}>
					<div className={`${styles.map__header} container d-flex flex-column`}>
						<div className={`d-flex justify-content-between flex-column flex-xl-row`}>
							<h1 className={`${styles.main__title}`}>
								{t('НАШИ ГЕО')}
							</h1>
							<h2 className={`${styles.main__subtitle}`}>
								{t('работаем по странам с лучшими ставками')}
							</h2>
						</div>
					</div>

				<GeoMap />
			</section>

			<div className="container">
				<section className={styles.offers}>
					<div>
						<div className={`${styles.offers__header} d-flex flex-column`}>
							<div className={`d-flex justify-content-between flex-column flex-xl-row`}>
								<h1 className={`${styles.main__title}`}>
									{t('У нас в финансах')}
								</h1>
								<h2 className={`${styles.main__subtitle}`}>
									{t('Наиболее профитные офферы с высокой ставкой')}
								</h2>
							</div>
							<div className={styles.navigate}>
								<svg width="32" height="2" viewBox="0 0 32 2" fill="none"
									 xmlns="http://www.w3.org/2000/svg">
									<rect y="0.400024" width="32" height="1.2" fill="#F8FFE4" />
								</svg>
								<Link className={styles.navigate__link} onClick={() => showRegLogModal('registration')} to='#'>{t('Все офферы')}</Link>
							</div>
						</div>

						<div className={styles.cards}>
							{/* if loading show skeleton layout or show offers */}
							{isLoading ? [...new Array(6)].map((_, index) => (
									<OfferCardSkeleton key={index} />))
								:
								data?.data?.items?.map((offer) => (<OfferCard key={offer.offer_id} offer={offer} />))
							}
						</div>
					</div>
				</section>

				<section className={styles.advantages} id="whyUs">
					<div>
						<div
							className={`${styles.advantages__header_block} d-flex flex-column flex-xl-row justify-content-between`}>
							<h1 className={`${styles.main__title}`}>
								{t('Почему мы?')}
							</h1>
							<h2 className={`${styles.main__subtitle}`}>
								{t('Классовые технологические преимущества')}
							</h2>
						</div>
						<ul className={styles.advantages__main_items}>
							{generalAdvantages.map((obj, i) => (
								<AdvantagesLandingItem {...obj} key={i} index={i} />
							))}
						</ul>
					</div>
				</section>


				<IndividualAdvantages data={individualAdvantages} />

				<section className={styles.statistics}>
					<div className={styles.statistics__row}>
						<div className={styles.statistics__item}>
							<h1>200+</h1>
							<p>{t('Лучших офферов')}</p>
						</div>
						<div className={styles.statistics__item}>
							<h1>{t('18 гео')}</h1>
							<p>({t('СНГ, Европа, Азия, USA, Latin America')})</p>
						</div>
						<div className={styles.statistics__item}>
							<h1>10 000</h1>
							<p>{t('Вебмастеров')}</p>
						</div>
						<div className={styles.statistics__item}>
							<h1>1 500+</h1>
							<p>{t('Новых клиентов каждый день')}</p>
						</div>
					</div>
				</section>

				<ReviewsBlock rev1={rev1}
							  rev2={rev2}
							  setRev1={setRev1}
							  setRev2={setRev2}
							  handleShow={handleShow}
							  getData={getData}
				/>

				<section className="slider_events">
						<div className="slider_events__header d-flex flex-column" >
							<div className={`d-flex justify-content-between flex-column flex-xl-row`}>
								<h1 className={`${styles.main__title}`}>
									{t('наши ивенты')}
								</h1>
								<h2 className={`${styles.main__subtitle}`}>
									{t('нетворкинг. прибыль.')}
								</h2>
							</div>
						</div>

						<SliderEvents events={events} showRegLogModal={showRegLogModal}/>
				</section>

				<section className={styles.motivation}>
					<div className={`${styles.motivation__wrapper} d-flex justify-content-between`}>
						<div className={styles.motivation__info}>
							<h1>{t('Начни')}</h1>
							<h2>{t('зарабатывать больше')} <br /> {t('с PDL-Profit')}</h2>
							<Button className='outline-green'
									onClick={() => showRegLogModal('registration')}>{t('Регистрация')}</Button>
						</div>
						<div className={styles.motivation__img}>
							<img src={dollar} alt="dollar" />
						</div>

						<div className={`${styles.motivation__after} d-flex align-items-center`}>
							<div className={styles.motivation__after_img}>
								<img src={logoCPA} alt="logo" />
							</div>
							<div className={styles.motivation__after_text}>
								{t('У нас самые толковые офферы, а не вот это вот всё...')}
							</div>
						</div>
					</div>
				</section>

				<ModalReviews
					show={show}
					handleClose={handleClose}
					name={tempdata[1]}
					position={tempdata[2]}
					link={tempdata[3]}
					text={tempdata[4]}
					photo={tempdata[5]}
				/>
			</div>
			<ContactsWidget />
		</div>
	)
}


export default Main;